const isSubscribedTo = ({ subscriptions }, event) => !!subscriptions.find((s) => s.event === event);

export default isSubscribedTo;
